import React, { ReactElement } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LoadingSkeleton = (): ReactElement => <Skeleton />;

export default LoadingSkeleton;
